import { object } from "prop-types";
import { observer } from "mobx-react";
import { Label } from "./Label";

export const ObserverLabel = observer(({
  label,
  ...labelProps
}) => {
  const { id, name, backgroundColor, fontColor } = label;
  
  return (
    <Label
      id={id}
      name={name}
      backgroundColor={backgroundColor}
      fontColor={fontColor}
      {...labelProps}
    />
  );
})

ObserverLabel.propTypes = {
  label: object,
}
